import { TimeSlot } from '../../../../types';

export default (availableTimes: TimeSlot[], day: Date): TimeSlot[] => {
  const times = availableTimes.filter(
    (d: TimeSlot) =>
      new Date(d.start).getDate() === day.getDate() &&
      new Date(d.start).getMonth() === day.getMonth(),
  );

  return times;
};
